/**
 * Bundled Logo Configuration
 * 
 * Auto-generated at build time from public/UserData/wedding-logo-config.json
 * DO NOT EDIT THIS FILE MANUALLY
 * 
 * Generated at: 2026-03-06T15:16:07.612Z
 */

export const bundledLogoConfig = {
  "type": "logo",
  "weddingText": "Wedding of Groom & Bride",
  "logoFileName": "Logo.png"
};

export default bundledLogoConfig;
